import {
  PlateDesignParamType,
  PlateDesignType,
} from '@/common/queries/selections/plateDesign/plateDesign.type';
import { fetchApi } from '@/config/axiosSetting';

export const getPlateDesignFunction = (
  param: PlateDesignParamType,
): Promise<PlateDesignType[]> => {
  return fetchApi.get('/selection_item/plate_design/wop_list/', {
    params: { vehicle_type: param?.type, insurance: param?.insurance },
  });
};
